
export class CourseHistorySchoolEnrollments {
      ID: number
      STUDENTS_ID: number
      SCHOOL_YEAR: string
      SCHOOL_NAME: string
      ENROLLMENT_TYPE: string
      ENROLLMENT_DATE: string
      WITHDRAWAL_DATE: string
      DEPARTURE_DATE: string
      GRADE: string
      REGION: CourseHistoryRegion
    }
    
    export class CourseHistoryRegion {
      CODE: string
      NAME: string
    }
    